import PaymentHistoryTable from './PaymentHistoryTable';

export default PaymentHistoryTable;
